import React from "react";
import { business } from "../data/business";
import { useLasVegasTime } from "../hooks/useLasVegasTime";
import { PulseDot } from "./ui/PulseDot";
export function LiveCallCard() {
  const time = useLasVegasTime();
  return <aside aria-label="Call us now" className="rounded-3xl p-[clamp(1.5rem,2.5vw,2.5rem)] text-white" style={{
    background: "rgba(15,30,51,0.72)",
    backdropFilter: "blur(18px) saturate(140%)",
    WebkitBackdropFilter: "blur(18px) saturate(140%)",
    border: "1px solid rgba(201,162,74,0.45)",
    boxShadow: "0 20px 60px rgba(0,0,0,0.45)"
  }} data-id="element-417" data-mp="i9ijqppmeluj">
      <p className="flex items-center gap-2.5 text-sm font-medium text-white" data-id="element-418" data-mp="3vhvfs72792j1">
        <PulseDot data-id="element-419" data-mp="3qjaes5f4ietj" />
        Available now
      </p>
      <p className="mt-5 font-serif text-[clamp(1.35rem,1.8vw,1.9rem)] leading-snug text-white" data-id="element-420" data-mp="3qklglzp0dci0">
        It's <time className="font-medium" data-id="element-421" data-mp="1tnmdpvw7k9zl">{time}</time> in Las Vegas —{" "}
        <span className="italic" data-id="element-422" data-mp="1orf9c7jgn6jr">and we're answering right now.</span>
      </p>
      <a href={business.phoneHref} className="mt-6 block font-serif text-[clamp(2.4rem,3.6vw,4rem)] leading-none tracking-tight tabular-nums text-[#D4B062] transition-colors duration-150 hover:text-gold" aria-label={`Call ${business.phoneDisplay}`} data-id="element-423" data-mp="1u4cgkxhaedv1">
        {business.phoneDisplay}
      </a>
      <div className="mt-6 h-px w-full bg-gold/45" aria-hidden="true" data-id="element-424" data-mp="1q429fhhrdhel" />
      <p className="mt-5 text-white" data-id="element-425" data-mp="2dufrcf6mpzvg">We answer every call — day or night.</p>
      <p className="mt-1 text-sm text-white/[0.78]" data-id="element-426" data-mp="2hvhqkw0jqbxf">Free consultation · 100% confidential</p>
    </aside>;
}